function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
import { render } from 'react-dom';
import { isBrowser } from '../../utils';
import { ToastManager } from './toast-manager';
var portalId = 'tqc-toast-portal';
class Toaster {
  /**
   * Initialize the manager and mount it in the DOM
   * inside the portal node.
   *
   * @todo
   *
   * Update toast constructor to use `PortalManager`'s node or document.body.
   * Once done, we can remove the `zIndex` in `toast.manager.tsx`
   */
  constructor() {
    var _this = this;
    _defineProperty(this, "createToast", void 0);
    _defineProperty(this, "removeAll", void 0);
    _defineProperty(this, "closeToast", void 0);
    _defineProperty(this, "updateToast", void 0);
    _defineProperty(this, "isToastActive", void 0);
    _defineProperty(this, "bindFunctions", methods => {
      this.createToast = methods.notify;
      this.removeAll = methods.closeAll;
      this.closeToast = methods.close;
      this.updateToast = methods.update;
      this.isToastActive = methods.isActive;
    });
    _defineProperty(this, "notify", function (message) {
      var _this$createToast;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      (_this$createToast = _this.createToast) === null || _this$createToast === void 0 ? void 0 : _this$createToast.call(_this, message, options);
    });
    _defineProperty(this, "close", id => {
      var _this$closeToast;
      (_this$closeToast = this.closeToast) === null || _this$closeToast === void 0 ? void 0 : _this$closeToast.call(this, id);
    });
    _defineProperty(this, "closeAll", options => {
      var _this$removeAll;
      (_this$removeAll = this.removeAll) === null || _this$removeAll === void 0 ? void 0 : _this$removeAll.call(this, options);
    });
    _defineProperty(this, "update", function (id) {
      var _this$updateToast;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      (_this$updateToast = _this.updateToast) === null || _this$updateToast === void 0 ? void 0 : _this$updateToast.call(_this, id, options);
    });
    _defineProperty(this, "isActive", id => {
      var _this$isToastActive;
      return (_this$isToastActive = this.isToastActive) === null || _this$isToastActive === void 0 ? void 0 : _this$isToastActive.call(this, id);
    });
    if (!isBrowser) return;
    var portal;
    var existingPortal = document.getElementById(portalId);
    if (existingPortal) {
      portal = existingPortal;
    } else {
      var _document$body;
      var div = document.createElement('div');
      div.id = portalId;
      (_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.appendChild(div);
      portal = div;
    }
    render( /*#__PURE__*/React.createElement(ToastManager, {
      notify: this.bindFunctions
    }), portal);
  }
}
export var toast = new Toaster();